export const makeScriptRequest = async (
  url: string,
  options?: {
    headers?: Record<string, unknown>;
  }
): Promise<void> => {
  const headers = options?.headers ?? {};
  const res = await fetch(url, {
    headers: {
      Accept: 'text/javascript',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': window.csrfToken(),
      ...headers,
    },
  });
  if (!res.ok) {
    throw new Error();
  }
  const text = await res.text();
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.appendChild(document.createTextNode(text));
  document.body.appendChild(script);
};
